module.exports = __webpack_public_path__ + "static/blog-img7-2b7a85e7afb79548e68cc0e06f08bc85.jpg";